// File: src/utils/helpers.js

/**
 * Classnames utility — joins truthy class strings.
 */
export function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

/**
 * Formats a number with locale-aware separators.
 */
export function formatNumber(num) {
  return Number(num).toLocaleString('en-CA');
}

/**
 * Validates an email address.
 */
export function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

/**
 * Debounce utility.
 */
export function debounce(fn, delay = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

/**
 * Client-side search against the SEARCH_INDEX.
 * Returns matching entries sorted by relevance.
 */
export function searchSite(query, index) {
  if (!query || query.trim().length < 2) return [];

  const terms = query.toLowerCase().trim().split(/\s+/);

  const scored = index
    .map((entry) => {
      const haystack = `${entry.title} ${entry.keywords} ${entry.description}`.toLowerCase();
      let score = 0;

      for (const term of terms) {
        if (entry.title.toLowerCase().includes(term)) score += 10;
        if (entry.keywords.toLowerCase().includes(term)) score += 5;
        if (entry.description.toLowerCase().includes(term)) score += 3;
        // Partial match
        const words = haystack.split(/\s+/);
        for (const word of words) {
          if (word.startsWith(term)) score += 1;
        }
      }

      return { ...entry, score };
    })
    .filter((entry) => entry.score > 0)
    .sort((a, b) => b.score - a.score);

  return scored;
}